import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { addChildren } from "../../services/Api";
import { useAuth } from "../../services/AuthContext";
import { useToast } from "../../services/ToastContext";
import Tooltip from "../../components/Tooltip";

const AddChildPage = () => {
  //sets some functions and states
  const { checkAuth } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [childrenList, setChildrenList] = useState([]);

  const [inputErrors, setInputErrors] = useState({
    inputFirstName: "",
  });

  const { guardianID, familyName, email, primaryRate, doCreateToken } =
    location.state || {};

  // Validation function
  const validateAddChildForm = () => {
    let valid = true;
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.inputName = "Name required";
      valid = false;
    }

    setInputErrors(newErrors);
    return valid;
  };

  const handleDoneButton = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    //also do error checking again? 

    try {
      const response = await addChildren(
        childrenList,
        guardianID,
        familyName,
        email,
        primaryRate,
        doCreateToken
      );

      if (response.token) {
        localStorage.setItem("token", response.token);
        await checkAuth();
      }

      showToast((childrenList?.length > 1 ? "Children" : "Child") + " Added");
      navigate("/landingpage");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function that is called when add child button is submitted
  const handleAddChild = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!validateAddChildForm()) {
      setIsLoading(false);
      return;
    }

    const child = { FirstName: firstName };
    setChildrenList((prevChildren) => [...prevChildren, child]);

    setFirstName("");
    setAlreadySubmitted(true);
    setIsLoading(false);
  };

  const handleRemoveChild = (indexToRemove) => {
    const updatedList = childrenList.filter(
      (_, index) => index !== indexToRemove
    );
    setChildrenList(updatedList);
    setAlreadySubmitted(updatedList.length > 0);
  };

  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-4">
            {/* Nested Row within Card Body */}
            <div className="row">
              <div className="col-lg-2 d-none d-lg-block bg-register-image" />
              <div className="col-lg-8">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h2 font-weight-bold text-gray-900 mb-4">
                      Add Your Child!
                    </h1>
                  </div>

                  {!doCreateToken && (
                    <button className="close-btn" onClick={() => navigate(-1)}>
                      <i className="fas fa-times"></i>
                    </button>
                  )}

                  <form className="user">
                    <div className="" style={{ display: "flex" }}>
                      <input
                        type="text"
                        className="form-control form-control-user"
                        id="firstNameInputAddChild"
                        placeholder="First Name"
                        style={{ width: "90%" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={firstName}
                      />
                      {/* <button
                        onClick={handleAddChild}
                        className={`confirm-btn ${isLoading ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                        disabled={isLoading}
                        style={{ width: "10%" }}
                      >
                        {isLoading ? "Adding..." : <i className="fas fa-plus fa-lg fa-fw mr-2 icon green" />}
                      </button> */}
                      <button
                        // className="icon-button"
                        className={`confirm-btn ${
                          isLoading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                        onClick={handleAddChild}
                        style={{
                          width: "11%",
                          fontSize: "20px",
                          margin: "0px",
                          marginLeft: "15px",
                        }}
                      >
                        <Tooltip
                          content={<i className="fas fa-plus fa-lg green" />}
                          description="Add"
                          isCustom={true}
                        />
                      </button>
                    </div>
                    {inputErrors.inputName && (
                      <p className="text-danger">{inputErrors.inputName}</p>
                    )}
                    <br />
                    {error && <p className="text-danger">{error}</p>}

                    {childrenList && childrenList.length > 0 && (
                      <div className="mb-4 p-3 bg-light rounded shadow-sm">
                        <h5 className="text-gray-700 mb-3 text-center">
                          Hit done to add:
                        </h5>
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                          {childrenList.map((child, index) => (
                            <div
                              key={index}
                              className="badge green-color text-white p-2 m-1 rounded-pill fs-5"
                              style={{
                                letterSpacing: "0.05em",
                                fontWeight: "normal",
                              }}
                            >
                              {child.FirstName}
                              <button
                                type="button"
                                onClick={() => handleRemoveChild(index)}
                                className="btn btn-sm btn-light text-dark ms-2 py-0 px-2"
                                style={{
                                  borderRadius: "100%",
                                  fontWeight: "bold",
                                  lineHeight: "1.7",
                                  marginLeft: "10px",
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <button
                      onClick={handleDoneButton}
                      className={`longer-btn p-3 pr-5 pl-5 blue-color ${
                        !alreadySubmitted
                          ? "opacity-50 cursor-not-allowed hover:longer-btn:hover"
                          : ""
                      }`}
                      style={!alreadySubmitted ? { pointerEvents: "none" } : {}}
                      disabled={!alreadySubmitted || isLoading}
                    >
                      {doCreateToken ? "Finish" : "Done"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddChildPage;
